import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetCancelledRefresh } from './user-browser-refresh.action';

export const UserBrowserRefreshDataStateName = 'userBrowserRefreshState';

export interface BrowserRefreshModel {
  hasUserCancelledRefresh: boolean;
  cancelledVersion: number | null;
}

@State<BrowserRefreshModel>({
  name: UserBrowserRefreshDataStateName,
  defaults: {
    hasUserCancelledRefresh: false,
    cancelledVersion: null,
  },
})
@Injectable()
export class BrowserRefreshState {
  @Selector()
  static hasUserCancelledRefresh(state: BrowserRefreshModel): boolean {
    return state.hasUserCancelledRefresh;
  }

  @Selector()
  static getCancelledVersion(state: BrowserRefreshModel): number {
    return state.cancelledVersion ?? 0;
  }

  @Action(SetCancelledRefresh)
  setCancelledRefresh(
    ctx: StateContext<BrowserRefreshModel>,
    action: SetCancelledRefresh,
  ): void {
    ctx.patchState({
      hasUserCancelledRefresh: action.data.hasUserCancelledRefresh,
      cancelledVersion: action.data.cancelledVersion,
    });
  }
}
